import React, {useEffect, useState} from "react";
import bgImage from "../../../assets/images/bg-sign-up-cover.jpeg";
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import FramerFade from "../../../components/Animation/Fade";
import {Button, FormControl, FormHelperText, InputAdornment} from "@mui/material";
import MDInput from "../../../components/MDInput";
import MDButton from "../../../components/MDButton";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {
    editEmailSetting,
    getEmailCode, getEmailCodeForForgetPW,
    getEmailCodeVerify,
    onErrorAlert,
    onSuccessAlert
} from "../../../actions";
import {noop} from "lodash";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import LocalStorage from "../../../utils/LocalStorage";
import {useTranslation} from "react-i18next";

const UserEmailEdit = ({setOpen,originalEmail,isNew,getUserInfoFetch}) => {
    const {t} = useTranslation();
    const darkMode = useSelector(state => state?.common?.darkMode,(prev, next) => prev === next)
    const userInfo = useSelector(state => state?.auth?.userSetting,(prev, next) => prev === next);
    const dispatch = useDispatch()
    const nav = useNavigate()
    const [activeStep, setActiveStep] = useState(0);
    const [code, setCode] = useState(Array(6).fill(''));
    const [seconds, setSeconds] = useState(0);
    const [show, setShow] = useState(true);


    useEffect(() => {
        if (isNew === true)
        setActiveStep(2)
    }, [isNew]);
    useEffect(() => {
        const intervalId = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
        }, 1000);
        if (seconds === 0) {
            setShow(false);
        } else {
            setShow(true)
        }

        return () => clearInterval(intervalId);
    }, [seconds]);
    useEffect(() => {
        if(activeStep === 0){
            // reset()
            clearErrors()
        }

        if(activeStep === 1 || activeStep === 3){
            setCode(Array(6).fill(''));
            setSeconds(99); // 重置秒数
        } else {

            setSeconds(0);

        }

        // if(activeStep === 5) {
        //     const apiGet = async () => {
        //         await dispatch(getVerificationCode(noop,onError))
        //     }
        //     apiGet().then()
        // }



    }, [activeStep])
    
    const handleChange = (e, index) => {
        const value = e.target.value;
        if (value.length <= 1) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            if (value && index < 5) {
                document.getElementById(`code-${index + 1}`).focus();
            }
        }
    };
    
    const handlePaste = (e) => {
        const pasteData = e.clipboardData.getData('text').slice(0, 6);
        const newCode = pasteData.split('');
        while (newCode.length < 6) {
            newCode.push('');
        }
        setCode(newCode);
        
        const lastFilledIndex = newCode.findIndex((char, i) => char === '' || i === newCode.length - 1);
        document.getElementById(`code-${lastFilledIndex}`).focus();
    };
    
    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && index > 0 && !code[index]) {
            document.getElementById(`code-${index - 1}`).focus();
        } else if (e.key === "Enter") {
            if (activeStep === 1) {
                submitOriginalCode();
            } else {
                submitCode();
            }
        }
    };
    
    const handleConfirmChangeEmail = async () => {
        if (!!originalEmail) {
            await dispatch(getEmailCodeForForgetPW(originalEmail,onConfirmChangeSuccess,onError))
            // onConfirmChangeSuccess()
        }
    }

    const handleVerifyEmail = async () => {

        if (!errors.email && getValues('email')!=='') {
            const email = getValues('email')
            await dispatch(getEmailCode(email,onEmailSuccess,onError))
            // onEmailSuccess()
        }else {
            if (getValues('email') ===''){
                dispatch(onErrorAlert(t('AccountPage.Please enter an email to continue')))
            }
        }


    }
    const onEmailSuccess = () => {
        setActiveStep(3)
        setCode(Array(6).fill(''));
    }

    const onConfirmChangeSuccess = () => {
        setActiveStep(1)
    }

    const handleResendVerifyOriginalEmail = async () => {
        if (!!originalEmail) {
            await dispatch(getEmailCodeForForgetPW(originalEmail,onEmailResendSuccess,onError))
            // onEmailResendSuccess()
        }
    }

    const handleResendVerifyEmail = async () => {
        if (!errors.email && getValues('email')!=='' ) {
            const email = getValues('email')
            await dispatch(getEmailCode(email,onEmailResendSuccess,onError))
            // onEmailResendSuccess()
        }
    }


    const handleVerifyOriginalEmailCode = async () => {
        submitOriginalCode();
    }

    const handleVerifyEmailCode = async () => {
        submitCode();
    }
    
    const submitOriginalCode = async () => {
        const formData = {};
        const verificationCode = code.join('');
        if(verificationCode!==''){
            formData.emailAddress = originalEmail
            formData.emailCode = verificationCode
            await dispatch(getEmailCodeVerify(formData ,onOriginalEmailVerifySuccess, onError))
            // onOriginalEmailVerifySuccess()
        }
    };
    
    const submitCode = async () => {
        const formData = {};
        const verificationCode = code.join('');
        if(verificationCode!==''){
            formData.emailAddress = getValues('email')
            formData.emailCode = verificationCode
            await dispatch(getEmailCodeVerify(formData,onEmailEdit,onError))
            // onEmailEdit()
        }
    };
    
    async function onOriginalEmailVerifySuccess() {
        setActiveStep(2)
    }


    async function onEmailEdit() {
        let userInfoCopy = {...userInfo}
        userInfoCopy.email = getValues('email')
        userInfoCopy.userName = localStorage.getItem('sub_username');
        const formData = {
            userInfo: userInfoCopy
        }
        await dispatch(editEmailSetting(formData, onEmailEditSuccess, onError))
        // onEmailEditSuccess()

    }

    const onEmailEditSuccess = async (msg) => {
        dispatch(onSuccessAlert(t(msg)))
        await getUserInfoFetch()
        setOpen(false)
    }


    const onEmailResendSuccess =() => {
        dispatch(onSuccessAlert(t('resend verification code successfully')))
        setSeconds(99);
    }



    const schema = yup
        .object({
            email: yup.string().trim().email().required(t("ForgotPasswordPage.Email is Required")),
        })

    const {register, setError, handleSubmit, getValues, setValue, clearErrors, formState: {errors}} = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    });

    const onSubmit = async (data) => {
        await handleVerifyEmailCode()
    }



    const onError = async (msg) => {
        dispatch(onErrorAlert(msg))
    }


    return(
        <React.Fragment>
            {/*<CoverLayout image={bgImage}>*/}
                    <MDBox
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="success"
                        mx={2}
                        mt={-3}
                        p={3}
                        mb={1}
                        textAlign="center"
                    >
                        <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                            {t('AccountPage.Link New Email Address')}
                        </MDTypography>
                        <MDTypography display="block" variant="button" color="white" my={1}>
                            {t('AccountPage.Change contact email for receiving verification code and more.')}
                        </MDTypography>
                    </MDBox>
                    <MDBox pt={4} pb={2} px={3}>
                        <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                            <div style={{overflow: "hidden"}}>
                                <FramerFade isActive={activeStep === 0} delay={0}>
                                    <MDBox mb={5} textAlign="center" >
                                        <MDTypography variant="h5" fontWeight="medium"  mt={1}>
                                            Are you sure you want to change your email?
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox mt={2} sx={{display: "flex", justifyContent: "space-around"}}>
                                        <MDButton variant="outlined" color="info" onClick={() => {
                                            setOpen(false)
                                        }}>
                                            {t('Cancel')}
                                        </MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleConfirmChangeEmail}>
                                            {t('Continue')}
                                        </MDButton>
                                    </MDBox>
                                </FramerFade>
                            </div>
                            <div style={{overflow: "hidden"}}>
                                <FramerFade isActive={activeStep === 1} delay={0}>
                                    <Grid textAlign='center'><Icon style={darkMode ? {color: 'white'} : {color: 'text'}}
                                                                   fontSize={'large'}>lock</Icon></Grid>
                                    <Typography variant={'h5'} align="center">{t('ForgotPasswordPage.Enter your verification Code')}</Typography>
                                    <MDTypography align="center" display="block" variant="button" my={1}>
                                        {`${t('AccountPage.We sent a verification code to you current email')}} ${originalEmail}`}
                                    </MDTypography>
                                    <MDBox component="form" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                                        <MDBox sx={{ display: 'flex', gap: 1 }} onPaste={handlePaste}>
                                            {code.map((digit, index) => (
                                                <TextField
                                                    key={index}
                                                    id={`code-${index}`}
                                                    value={digit}
                                                    onChange={(e) => handleChange(e, index)}
                                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                                    InputProps={{autoComplete: 'off', maxLength: 1, style: { textAlign: 'center' } }}
                                                    autoFocus={index === 0}
                                                    sx={{
                                                        width: '40px', height: '20px', '& .MuiOutlinedInput-input': {
                                                            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                                '-webkit-appearance': 'none',
                                                            }
                                                        }
                                                    }}
                                                />
                                            ))}
                                        </MDBox>
                                    </MDBox>
                                    <MDBox mt={4} display="flex" alignItems="center" justifyContent="start">
                                        <MDTypography display="block" variant="button">
                                            {t(`ForgotPasswordPage.Haven't receive a code?`)}
                                        </MDTypography>
                                        <Button sx={{padding: 1}} onClick={handleResendVerifyOriginalEmail}
                                                disabled={show}>{t('Resend')}</Button>
                                        <MDTypography display="block" variant="button">
                                            {show && `${seconds}s`}
                                        </MDTypography>
                                    </MDBox>

                                    <MDBox mt={2} sx={{display: "flex", justifyContent: "space-around"}}>
                                        <MDButton variant="outlined" color="info"
                                                  onClick={() => {
                                                      setOpen(false)
                                                  }}
                                        >
                                            cancel
                                        </MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleVerifyOriginalEmailCode}>
                                            Verify
                                        </MDButton>
                                    </MDBox>

                                </FramerFade>

                            </div>
                            <div style={{overflow: "hidden"}}>
                                <FramerFade isActive={activeStep === 2} delay={0}>
                                    <MDTypography align="center" variant="h5" fontWeight="medium"  my={1}>

                                        { isNew !== true && "Original email verified successfully,"}

                                        {t('AccountPage.Please enter your new email.')}
                                    </MDTypography>
                                    <MDBox mb={2} mt={2}>
                                        <FormControl
                                            error={!!errors.email}
                                            fullWidth
                                            required
                                            focused={true}
                                        >
                                            <MDInput
                                                type="email"
                                                label={t("Email")}
                                                variant="standard"
                                                fullWidth
                                                required
                                                {...register("email")}
                                                error={!!errors?.email}
                                            />
                                            <FormHelperText
                                                sx={{fontWeight: 'medium'}}>{errors?.email?.message}</FormHelperText>
                                        </FormControl>

                                    </MDBox>
                                    <MDBox mt={2} sx={{display: "flex", justifyContent: "space-around"}}>
                                        <MDButton variant="outlined" color="info" onClick={() => {
                                            setOpen(false)
                                        }}>
                                            {t('Cancel')}
                                        </MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleVerifyEmail}>
                                            {t('Continue')}
                                        </MDButton>
                                    </MDBox>
                                </FramerFade>

                            </div>

                            <div style={{overflow: "hidden"}}>
                                <FramerFade isActive={activeStep === 3} delay={0}>
                                    <Grid textAlign='center'><Icon style={darkMode ? {color: 'white'} : {color: 'text'}}
                                                                   fontSize={'large'}>lock</Icon></Grid>
                                    <Typography variant={'h5'} align="center">{t('ForgotPasswordPage.Enter your verification Code')}</Typography>
                                    <MDTypography align="center" display="block" variant="button" my={1}>
                                        {`${t('AccountPage.We send a verification code to')} ${getValues('email')}`}
                                    </MDTypography>
                                    <MDBox component="form" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                                        <MDBox sx={{ display: 'flex', gap: 1 }} onPaste={handlePaste}>
                                            {code.map((digit, index) => (
                                                <TextField
                                                    key={index}
                                                    id={`code-${index}`}
                                                    value={digit}
                                                    onChange={(e) => handleChange(e, index)}
                                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                                    InputProps={{autoComplete: 'off', maxLength: 1, style: { textAlign: 'center' } }}
                                                    autoFocus={index === 0}
                                                    sx={{
                                                        width: '40px', height: '20px', '& .MuiOutlinedInput-input': {
                                                            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                                '-webkit-appearance': 'none',
                                                            }
                                                        }
                                                    }}
                                                />
                                            ))}
                                        </MDBox>
                                    </MDBox>
                                    <MDBox mt={4} display="flex" alignItems="center" justifyContent="start">
                                        <MDTypography display="block" variant="button">
                                            {t(`ForgotPasswordPage.Haven't receive a code?`)}
                                        </MDTypography>
                                        <Button sx={{padding: 1}} onClick={handleResendVerifyEmail}
                                                disabled={show}>{t('Resend')}</Button>
                                        <MDTypography display="block" variant="button">
                                            {show && `${seconds}s`}
                                        </MDTypography>
                                    </MDBox>

                                    <MDBox mt={2} sx={{display: "flex", justifyContent: "space-around"}}>
                                        <MDButton variant="outlined" color="info"
                                                  onClick={() => {
                                                      setOpen(false)
                                                  }}
                                        >
                                            {t('Cancel')}
                                        </MDButton>
                                        <MDButton variant="gradient" color="info" type='submit'>
                                            {t('Verify')}
                                        </MDButton>
                                    </MDBox>

                                </FramerFade>
                            </div>
                        </MDBox>
                    </MDBox>
            {/*</CoverLayout>*/}
        </React.Fragment>
    )
}
export default UserEmailEdit